"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _uuid = require("uuid");

var _coreOverlayController = require("@legacy-vfuk/core-overlay-controller");

var Modal = function Modal(_ref) {
  var _ref$isClosable = _ref.isClosable,
      isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$onCloseCb = _ref.onCloseCb,
      onCloseCb = _ref$onCloseCb === void 0 ? null : _ref$onCloseCb,
      _ref$initialFocusId = _ref.initialFocusId,
      initialFocusId = _ref$initialFocusId === void 0 ? null : _ref$initialFocusId,
      focusEnabledRefs = _ref.focusEnabledRefs,
      children = _ref.children,
      _ref$animate = _ref.animate,
      animate = _ref$animate === void 0 ? true : _ref$animate,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size,
      srName = _ref.srName,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'modal' : _ref$type,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? 'right' : _ref$side,
      _ref$overlayBlur = _ref.overlayBlur,
      overlayBlur = _ref$overlayBlur === void 0 ? false : _ref$overlayBlur,
      id = _ref.id,
      _ref$fullScreenOnSM = _ref.fullScreenOnSM,
      fullScreenOnSM = _ref$fullScreenOnSM === void 0 ? false : _ref$fullScreenOnSM,
      header = _ref.header,
      footer = _ref.footer,
      rootElement = _ref.rootElement,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'Modal';
  var modalId = (0, _react.useRef)(id || (0, _uuid.v4)());
  (0, _react.useEffect)(function () {
    if (isOpen) {
      _coreOverlayController.overlayController.setConfig(modalId.current, {
        isShowing: true,
        isClosable: isClosable,
        onCloseCb: onCloseCb,
        initialFocusId: initialFocusId,
        focusEnabledRefs: focusEnabledRefs,
        content: children,
        animate: animate,
        srName: srName,
        type: type,
        header: header,
        footer: footer,
        rootElement: rootElement,
        renderOptions: {
          size: size,
          appearance: appearance,
          side: side,
          overlayBlur: overlayBlur,
          fullScreenOnSM: fullScreenOnSM
        },
        id: modalId.current,
        dataSelectorPrefix: dataSelectorPrefix,
        dataAttributes: dataAttributes,
        componentName: componentName
      });
    } else {
      _coreOverlayController.overlayController.hide(modalId.current);
    }
  }, [isOpen, isClosable, onCloseCb, initialFocusId, focusEnabledRefs, children, animate, size, srName, appearance, side, overlayBlur, type, id, dataSelectorPrefix, dataAttributes]); // Destructor to be run when the component unmounts

  (0, _react.useEffect)(function () {
    return function () {
      if (isOpen) {
        _coreOverlayController.overlayController.hide(modalId.current);
      }
    };
  }, []);
  return null;
};

var _default = Modal;
exports["default"] = _default;
//# sourceMappingURL=Modal.js.map